import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { cleanObj } from '../../../../../../shared/utils/objects';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import { asyncGetParams } from '../../../../../../services/param.service';
import { AlertProps } from './props';
import { AlertSection } from '../../../../../../shared/types/legalProceedings/alerts';
import { asyncGetTemplate } from '../../../../../../services/alerts.service';

export const useAlert = ({
    data,
    onChangeData,
    onChangeFormik,
    formikStatus,
    formikProcess,
    formikAlertStatus,
    formikAlert,
}: AlertProps) => {
    const [typesStatus, setTypesStatus] = useState<ISelect[]>([]);
    const [typesAlertDate, setTypesAlertDate] = useState<ISelect[]>([]);
    const [typesClassification, setTypesClassification] = useState<ISelect[]>(
        []
    );

    const alertByMail = formikAlert?.values?.alertByMail;
    const newPqrStatus = formikAlertStatus?.values?.newPqrStatus || '';
    const status = formikStatus?.values?.status || '';
    const receptionChannel = formikProcess?.values?.receptionChannel || '';
    const typePQR = formikProcess?.values?.typePQR || '';
    const receivedThrough = formikProcess?.values?.receivedThrough || '';
    const transaction = formikProcess?.values?.transaction || '';
    const alertDate = formikAlert?.values?.alertDate || '';

    const onSubmit = (data: AlertSection) => {
        if (onChangeData) onChangeData(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('alertDate', data?.alertDate || '');
        formik?.setFieldValue('classification', data?.classification || '');
        formik?.setFieldValue('numberDays', data?.numberDays || '');
        formik?.setFieldValue('alertByMail', data?.alertByMail || false);
        formik?.setFieldValue('emailOfficials', data?.emailOfficials || '');
        formik?.setFieldValue('tags', data?.tags || '');
        formik?.setFieldValue('subject', data?.subject || '');
        formik?.setFieldValue(
            'template',
            data?.template ||
                `
            Este es un mensaje informativo por favor no respondas, ante cualquier consulta realizarla al buzón: <span>contactenos@previsora.gov.co</span><br>
            Señores: <span>&nbsp;</span><br>
            Área Encargada: <span>SUBGERENCIA DE INDEMNIZACIONES SOAT, VIDA Y AP</span><br>
            <br>
            Recordamos que la PQR No.: <span>@PQR-ID@</span><br>
            Fecha de recepción: <span>@PQR-DATE@</span><br>
            Fecha límite de respuesta: <span>@PQR-DATE-END@</span><br>
            <br>
            No olvide tener en cuenta: <span>&nbsp;</span><br>
            - Si el caso no es de su competencia, realizar la devolución de forma inmediata o más tardar el día siguiente hábil para ser reasignado.<br>
            - En caso de no poder atender la PQR en esta fecha, se debe solicitar con anterioridad al vencimiento la prórroga, justificando debidamente el porqué de esta.<br>
            - La respuesta debe ser clara, precisa, de fondo, coherente, atendiendo cada una de las solicitudes planteadas.<br>
            - La copia de la respuesta deberá ser enviada a la Gerencia de Servicio a más tardar al día hábil siguiente para el cierre oportuno de las PQR al correo: <span>contactenos@previsora.gov.co</span>, junto con los anexos si aplica, guía de envío, sello de recibido y/o correo electrónico.<br>
            - Se debe emitir copia de la respuesta del aliado.<br>
            <br>
            Datos Aliado: <span>&nbsp;</span><br>
            Nombre: <span>@PQR-ALLY-NAME@</span><br>
            Correo: <span>@PQR-ALLY-EMAIL@</span><br>
            <br>
            Datos PQR Cliente: <span>&nbsp;</span><br>
            Nombre: <span>@PQR-ACCOUNT-NAME@</span><br>
            Identificación: <span>@PQR-ACCOUNT-DOCUMENT@</span><br>
            E-mail: <span>@PQR-ACCOUNT-EMAIL@</span><br>
            Teléfono: <span>@PQR-ACCOUNT-PHONE@</span><br>
            Dirección: <span>@PQR-ACCOUNT-ADDRESS@</span><br>
            Ciudad: <span>@PQR-ACCOUNT-CITY@</span><br>
            Tipo PQR: <span>@PQR-TYPE@</span><br>
            Medio: <span>@PQR-HALF@</span><br>
            <br>
            Datos Notificación Cliente: <span>&nbsp;</span><br>
            Email notificación: <span>@PQR-NOTIFICATION-EMAIL@</span><br>
            Teléfono notificación: <span>@PQR-NOTIFICATION-PHONE@</span><br>
            Dirección notificación: <span>@PQR-NOTIFICATION-ADDRESS@</span><br>
            <br>
            Detalle PQR: <span>@PQR-DETAIL@</span><br>
            <br>
            Cordial saludo, <span>&nbsp;</span><br>
            <br>
            Contáctenos: <span>Gerencia de Servicio</span><br>
            Vicepresidencia Comercial: <span>(571) 3487555 - #345 Opción 3</span><br>
            Email: <span>contactenos@previsora.gov.co</span><br>
            Dirección: <span>Calle 57 # 9 – 07, Casa Matriz Bogotá</span><br>
        `
        );
    }, [data]);

    useEffect(() => {
        if (
            !alertByMail ||
            !newPqrStatus ||
            !status ||
            !receptionChannel ||
            !typePQR ||
            !receivedThrough ||
            !transaction ||
            !alertDate
        ) {
            return;
        }

        if (!data) {
            asyncGetTemplate({
                newPqrStatus,
                status,
                receptionChannel,
                typePQR,
                receivedThrough,
                transaction,
                alertDate,
            }).then((res) => {
                formik.setFieldValue('template', res?.body || '');
                formik.setFieldValue('subject', res?.subject || '');
            });
        }
    }, [
        alertByMail,
        newPqrStatus,
        status,
        receptionChannel,
        typePQR,
        receivedThrough,
        transaction,
        alertDate,
    ]);

    useEffect(() => {
        asyncGetParams(ParamEnum.ALERTS_STATUS).then((params) =>
            setTypesStatus(params)
        );
        asyncGetParams(ParamEnum.ALERTS_ALERT_DATE).then((params) =>
            setTypesAlertDate(params)
        );
        asyncGetParams(ParamEnum.ALERTS_CLASSIFICATION).then((params) =>
            setTypesClassification(params)
        );
    }, []);

    return {
        formik,
        typesStatus,
        typesAlertDate,
        typesClassification,
    };
};
